export const Navbar = {
  align: "enum(left,center,right)",
  "base-url": "string",
  hamburger: "string",
  "container-background-color": "color",
  "ico-align": "enum(left,center,right)",
  "ico-open": "string",
  "ico-close": "string",
  "ico-color": "color",
  "ico-font-size": "unit(px,%)",
  "ico-font-family": "string",
  "ico-text-transform": "string",
  "ico-padding": "unit(px,%){1,4}",
  "ico-padding-left": "unit(px,%)",
  "ico-padding-top": "unit(px,%)",
  "ico-padding-right": "unit(px,%)",
  "ico-padding-bottom": "unit(px,%)",
  padding: "unit(px,%){1,4}",
  "padding-left": "unit(px,%)",
  "padding-top": "unit(px,%)",
  "padding-right": "unit(px,%)",
  "padding-bottom": "unit(px,%)",
  "ico-text-decoration": "string",
  "ico-line-height": "unit(px,%,)",
};
